import { Skeleton, Typography } from "antd";
import { MediaElement } from "./MediaElement";
import type { ImageElement } from "./types";
import type { MediaAsset } from "pages/media/types";
import { radius } from "@libertify/ui";

interface MediaRenderProps {
  imageElement: ImageElement | undefined;
  imageUrl: string | undefined;
  imageAsset: MediaAsset | undefined;
  isLoading: boolean;
}

export const MediaRender = ({
  imageElement,
  imageUrl,
  imageAsset,
  isLoading,
}: MediaRenderProps) => {
  if (isLoading) {
    return <Skeleton.Image active style={{ width: "100%", height: 200 }} />;
  }

  if (imageUrl) {
    return (
      <MediaElement
        src={imageUrl}
        width={400}
        height={225}
        borderRadius={radius.box}
        assetPath={imageAsset?.data?.path}
      />
    );
  }

  return (
    <Typography.Text type="secondary" italic>
      {imageElement?.description}
    </Typography.Text>
  );
};
